export enum PrimaryButtonLabels {
  Next = 'Next',
  Last = 'Last',
}
